import { isUndefined } from 'lodash';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import {
  ExclusionType,
  SelfExclusion,
  exclusionTypeTimeouts,
  exclusionTypeTimeoutsIT
} from '../definitions';

const useExclusionType = (daysRequested?: number, nationalExclusion?: boolean) => {
  const license = useSelector(select.account.getLicense);
  const showVegasContent = useSelector(select.site.showVegasContent);
  const selExclusion = nationalExclusion ? SelfExclusion.Nationally : SelfExclusion.Brand;
  const { [ExclusionType.Break]: takeBreak } =
    exclusionTypeTimeouts(license, showVegasContent) || exclusionTypeTimeoutsIT[selExclusion];

  if (isUndefined(daysRequested)) {
    return;
  }

  return takeBreak.includes(daysRequested) ? ExclusionType.Break : ExclusionType.SelfExclusion;
};

export default useExclusionType;
